import React from "react";
import Select from "react-select";
import { SUPPORTED_API_OPTIONS } from "./ApiDropdownConfigurator.utils";
import { FieldProps } from "../../../../../../../InputFieldsController/InputFieldsController.utils";

/**
 * Props for configuring API-based dropdown source
 */
interface ApiDropdownConfiguratorProps {
  field: FieldProps;
  onChange: (updates: Partial<FieldProps>) => void;
}

/**
 * Form Builder component to configure API source
 * for Select dropdowns that fetch options dynamically.
 */
const ApiDropdownConfigurator: React.FC<ApiDropdownConfiguratorProps> = ({
  field,
  onChange,
}) => {
  const selectedApi = field.apiConfig?.apiKey;
  const selectedOption = SUPPORTED_API_OPTIONS.find(
    (opt) => opt.value === selectedApi
  ) || null;

  return (
    <div style={{ marginTop: 12 }}>
      <label style={{ fontWeight: 500, fontSize: 10 }}>
        Source
      </label>
      <Select
        isClearable
        options={SUPPORTED_API_OPTIONS}
        value={selectedOption}
        onChange={(selected) => {
          const selectedApiKey = selected?.value ?? "";
          onChange({
            apiConfig: {
              ...(field.apiConfig || {}),
              apiKey: selectedApiKey,
              fetchedOptions: [],
            },
          });
          
        }}
        placeholder="Select source"
        className="custom-select"
        classNamePrefix="react-select"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
        }}
      />
    </div>
  );
};

export default ApiDropdownConfigurator;
